import { render, staticRenderFns } from "./PropertyListPage.vue?vue&type=template&id=41e1326a&"
import script from "./PropertyListPage.vue?vue&type=script&lang=ts&"
export * from "./PropertyListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports